import { FormControlLabel, Checkbox } from "@mui/material";

import { HoverHelp } from "components/utility/HoverHelp";

import { checkForUnexpectedProps } from "services/utility/misc";

export function FrmCheckboxWithHoverHelp(props) {
  const {
    name,
    value,
    onValueChange,
    label,
    helpText,
    disabled,
    ...unexpected
  } = props;
  checkForUnexpectedProps("FrmCheckbox", unexpected);

  return (
    <div style={{ display: "flex", alignItems: "start" }}>
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            checked={value}
            disabled={disabled}
            onChange={(e) => onValueChange(e.target.name, e.target.checked)}
            sx={{ py: 0 }}
          />
        }
        label={label}
        sx={{ alignItems: "start", mr: "0.5rem" }}
      />
      <HoverHelp title={helpText} />
    </div>
  );
}
